import { Portal } from '@material-ui/core';
import { FileCollectionT, ImageCollectionItemT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, createRef, useContext, useMemo, useState } from 'react';
import { Modal } from '../../../../overlay';
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';
import { IconButton } from '@mui/material';
import { ArrowForwardIosRounded, Close } from '@mui/icons-material';
import { ObosChevronRight, ObosX } from '../../../../../icons/obos/obosIcons';
import { isLandscape } from '../../../../../utils/app.helper';
import { AppContext } from '../../../../../state/app.state';
import BrandingService from '../../../../../services/branding.service';

type ObjectViewMobileFloorplanProps = {
    selectedObject?: ObjectContainerClientT;
    fileCollections?: FileCollectionT[];

};

const ObjectViewMobileFloorplan: React.FC<ObjectViewMobileFloorplanProps> = ({ selectedObject, fileCollections }): ReactElement => {
    const { state } = useContext(AppContext);
    const [selectedFloorplan, setSelectedFloorplan] = useState<ImageCollectionItemT>();
    const [zoom, setZoom] = useState<ReactZoomPanPinchRef>();
    const floorplanCollection = useMemo(() => selectedObject && fileCollections?.filter(fc => fc.type === 'floor-plan')?.find(fc => fc.id === selectedObject?.floorPlanCollectionId), [fileCollections, selectedObject]);
    const [imageIndex, setImageIndex] = useState(0);
    const imageArrayLength = floorplanCollection?.files?.length;
    const transformRef = createRef<ReactZoomPanPinchRef>();
    const changeImageIndex = (direction: 'prev' | 'next') => {
        if (!imageArrayLength) return;
        transformRef?.current?.resetTransform();
        switch (direction) {
        case 'prev':
            imageIndex !== 0 && setImageIndex(imageIndex - 1);
            break;
        case 'next':
            imageIndex !== imageArrayLength - 1 && setImageIndex(imageIndex + 1);
            break;
        }
    };

    const getArrow = () => {

        if (BrandingService.check(['obos']))
            return <ObosChevronRight/>;

        return <ArrowForwardIosRounded/>;
    };

    return (
        <div className='bv-object-view-mobile-content-left-subcolumn'>
            <div className='bv-object-view-mobile-floorplan-container'>
                <div className='bv-object-view-mobile-floorplan-container-sub'>
                    {selectedObject && floorplanCollection?.files?.slice().sort((a, b) => {
                        return a.sortOrder - b.sortOrder;
                    })
                        ?.map((f, i) => {
                            return i === 0 && f.type === 'image' && <img key={f.id} className={'bv-object-view-mobile-floorplan'} alt='floorplan' src={f.url?.small as unknown as string} onClick={(): void => setSelectedFloorplan(f as ImageCollectionItemT)} />;
                        })}
                </div>
            </div>
            {selectedFloorplan && <Portal>
                <Modal
                    className={'bv-object-view-mobile-floorplan-modal'}
                    showModal={!!selectedFloorplan}
                    modalPaperStyle={{ maxHeight: '80vh' }}
                    onBackdropClick={(): void => setSelectedFloorplan(undefined)}
                >
                    <div className={'bv-objectview-close'} style={{ width: '3rem', height: '3rem', borderRadius: '1.5rem' }} onClick={(): void => setSelectedFloorplan(undefined)}>
                        <ObosX className={'bv-obos-x'}
                            style={{
                                width: '1.5rem',
                                height: '1.5rem',
                                padding: '0.75rem'
                            }} />
                    </div>
                    {imageIndex !== 0 && floorplanCollection && floorplanCollection?.files.length > 1 && <IconButton className='bv-object-view-image-button bv-object-view-image-button-left bv-object-view-image-button--fp' onClick={(): void => changeImageIndex('prev')}>{getArrow()}</IconButton> }
                    <TransformWrapper ref={transformRef} limitToBounds={true} centerOnInit={true} initialScale={1} onZoom={(ref, event) => {
                        setZoom(ref);
                    }}>
                        <TransformComponent>
                            <img className={'bv-object-view-mobile-floorplan-modal-img'} src={floorplanCollection?.files.find((f, i) => i === imageIndex)?.url?.original} alt='' />
                        </TransformComponent>
                    </TransformWrapper>
                    {floorplanCollection && imageIndex < floorplanCollection?.files.length - 1 && floorplanCollection?.files.length > 1 && <IconButton className='bv-object-view-image-button bv-object-view-image-button-right bv-object-view-image-button--fp' onClick={(): void => changeImageIndex('next')}>{getArrow()}</IconButton>}
                </Modal>
            </Portal>}
        </div>
    );
};


export default ObjectViewMobileFloorplan;